import type { App } from 'vue';
import type {
  ParseToDate,
  ParseToDateTime,
} from '@/common/composition/useLuxon';
import useLuxon from '@/common/composition/useLuxon';

const { parseToDate, parseToDateTime } = useLuxon();

const LuxonVuePlugin = {
  install(app: App<Element>) {
    app.mixin({
      methods: {
        parseToDate,
        parseToDateTime,
      },
    });
  },
};

export default LuxonVuePlugin;

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    parseToDate: ParseToDate;
    parseToDateTime: ParseToDateTime;
  }
}
